//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
    return {
      show: false,
    };
  },
  
  props: {
    name: {
      type: String,
      default: '',
    },
    permalink: {
      type: String,
    },
    position: {
      type: String,
    },
    size: {
      type: String,
      default: 'one',
    },
    background: {
      default: require('../../images/dummy_image.jpg'), 
    },
  },
  
  computed: {
    styles: function() {
      return {
        'background-image': 'url(' + this.background + ')',
      };
    },
  },
  
  watch: {

  },
  
  methods: {
    mouseover: function(){
      this.show = true
    },    
    mouseleave: function(){
      this.show = false
    },
  },
  
  components: {

  },
  
  created() {
    
  },
  mounted() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/TeamMember.vue